/*document.querySelectorAll('#filters-mobile-menu .close-filters, #filters-mobile-menu .filters-mobile-menu-background').forEach(closeElement => {
  closeElement.addEventListener('click', () => {
    document.getElementById('filters-mobile-menu').style.display = 'none'
    document.body.style.overflow = "auto"
  })
});

document.querySelectorAll('.collection-top .checkbox-overlay').forEach(overlay => {
  overlay.addEventListener('click', e => {
    document.getElementById('filters-mobile-menu').setAttribute('style', 'display:flex;')
    document.body.style.overflow = "hidden"
  })
});

const currentFilters = window.location.pathname.split('/')[3]?.split('+') || ['']

const updateCheckboxes = (tagsArray = []) => {
  if(tagsArray.length > 0) {
    document.querySelectorAll('.filters-form input[type="checkbox"]').forEach(element => {
      element.checked = tagsArray.includes(element.getAttribute('value'))
    })
  }
};
      
updateCheckboxes(currentFilters)
      
document.querySelectorAll('.filters-form .filter-name').forEach(element => {
  const filterName = element
  const checkboxContainer = filterName.closest('.checkbox-container')
  filterName.addEventListener('click', e => {
    if (checkboxContainer.classList.contains('active')) {
      checkboxContainer.classList.remove('active')
    } else {
      document.querySelectorAll('.filters-form .checkbox-container').forEach(el => {
        el.classList.remove('active')
      })
      checkboxContainer.classList.add('active')
    }
  })
})
      
document.querySelectorAll('.checkbox-container').forEach(element => {
  const checkboxContainer = element
  const checkboxes = checkboxContainer.querySelectorAll('input[type="checkbox"]')
  const filterCountElement = checkboxContainer.querySelector('.filter-count')
  let filterCount = 0

  const updateCount = (filterCount, filterCountElement) => {
    if(filterCount == 0) {
      filterCountElement.innerHTML = ''
    } else {
      filterCountElement.innerHTML = `: ${filterCount} selected`
    }
  }
  updateCount(filterCount, filterCountElement)

  checkboxes.forEach(checkbox => {
    if(checkbox.checked) {
      filterCount = filterCount + 1
    }
    updateCount(filterCount, filterCountElement)
    checkbox.addEventListener('click', e => {
      $s.showLoadingOverlay();

      const checkboxValue = e.target.getAttribute('value')

      if(e.target.checked) {
        if(currentFilters.indexOf(checkboxValue) == -1) {
          currentFilters.push(checkboxValue)
        }
      } else {
        const filterIndex = currentFilters.indexOf(checkboxValue)
        if(filterIndex >= 0){
          currentFilters.splice(filterIndex, 1)
        }
      }

      const currentURL = window.location.href
      const currentPath = window.location.pathname

      let newPath = currentPath.split('/')
      newPath[3] = currentFilters.join('+')
      newPath = newPath.join('/')
      let newURL = currentURL.replace(currentPath, newPath)
      window.location.replace(newURL)
    })
  })
})
*/
const setProductsListHeight = () => {
  const products = document.querySelectorAll('.collection-grid .product-item product-card')
  if (products.length > 0) {
    const gridCollectionOverlay = document.querySelector('.grid-collection-overlay')
    gridCollectionOverlay.setAttribute('style', 'display:none;')

    const firstProduct = products[0]
    const lastProduct = products[products.length - 1]

    const productsSectionTopPosition = firstProduct.getBoundingClientRect().top
    const productsSectionBottomPosition = lastProduct.getBoundingClientRect().bottom

    const productSectionFinalHeight = productsSectionBottomPosition - productsSectionTopPosition

    document.querySelector('.collection-grid').style.height = productSectionFinalHeight + 'px'

    const lastProductTop = lastProduct.getBoundingClientRect().top - productsSectionTopPosition
    const lastProductRight = lastProduct.getBoundingClientRect().right + 10
    
    gridCollectionOverlay.setAttribute('style', `display:block;top:${lastProductTop}px;left:${lastProductRight}px;`)
  }
}

// Sticky Filters
/*var filters_wrapper = document.querySelector(".sticky-filters");
var cutValueMobile = Number(filters_wrapper.dataset.cutValueMobile);
window.addEventListener('scroll', (e) => {
  if(window.scrollY >= cutValueMobile)
    addShow(filters_wrapper);
  else
    removeShow(filters_wrapper);
})

if(window.scrollY >= cutValueMobile)
  addShow(filters_wrapper);
else
  removeShow(filters_wrapper);

function addShow(filters_wrapper){
  if(!filters_wrapper.classList.contains('sticky-filters-enabled')){
    filters_wrapper.classList.add('sticky-filters-enabled');
  }
}

function removeShow(filters_wrapper){
  if(filters_wrapper.classList.contains('sticky-filters-enabled')){
    filters_wrapper.classList.remove('sticky-filters-enabled');
  }
}
*/
//setProductsListHeight();

// window.addEventListener('resize', () => {
//   setProductsListHeight();
// })